import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { PortalInfo } from "app/shared/services/portal-info";
import { PageInfo } from "app/shared/services/page-info";
import { Response, Headers, Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as emiGlobals from 'app/globals';
import { Subject } from "rxjs/Subject";


@Injectable()
export class EmiBaseInfoService {
  
  localCustomerInfoData: JSON;
  hasLocalCustomerInfoData: boolean = false;
  localLeadData: JSON;
  hasLocalLeadData: boolean = false;
  
  private portalBasicInfoUrl = emiGlobals.portalInfoUrl;
  private pageInfoUrl = emiGlobals.pageInfoUrl;
  private pageInfoByUrl = emiGlobals.pageInfoByUrl;//pageInfoByUrl;
  private emileadSubmissionUrl = emiGlobals.commonLeadUrl;


  private pageDataFetchedSource = new Subject<string>();
  pageDataFetched$ = this.pageDataFetchedSource.asObservable();

  private portalDataFetchedSource = new Subject<string>();
  portalDataFetched$ = this.portalDataFetchedSource.asObservable();

 private urlFetchedSource = new Subject<string>();
 urlFetched$ = this.urlFetchedSource.asObservable();

  constructor(
    private _http: Http
  ){
  }

  private headers: Headers ;
  private options: RequestOptions ;

  doRequest(){
    let token =  localStorage.getItem('id_token');
    if(token==null){
      var loop = this.doRequest();
      console.log('EmiBaseInfoService - Token not available')
      setTimeout(loop, 2000);
    }
    this.headers= new Headers( {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Access-Control-Allow-Headers': 'Content-Type',
    }); 
    this.headers.append('Authorization','Bearer '+token);
    this.options = new RequestOptions ({ headers: this.headers} );
    console.log("doRequest",this.options);
  }

  getPortalPolicies(url){
    debugger
    this.doRequest();
    return  this._http.get(url,this.options).map(res => res.json());
   }

   public getPortalInfo() : Observable<PortalInfo[]> {

        this. doRequest();
         // ...using get request
         return this._http.get(this.portalBasicInfoUrl, this.options)
              // ...and calling .json() on the response to return data
              .map((res:Response) => res.json().portalInfo)
              //...errors if any
              .catch((error:any) => Observable.throw(error || 'Server error'));
   }

   public getPageInfo() : Observable<PageInfo[]> {
        this. doRequest();
         // ...using get request
         return this._http.get(this.pageInfoUrl, this.options)
              // ...and calling .json() on the response to return data
              .map((res:Response) => res.json().pageInfo)
              //...errors if any
              .catch((error:any) => Observable.throw(error || 'Server error'));
   }

   public getPageInfoByUrl(jsonData:JSON) : Observable<any> {
      try {
        this. doRequest();
        let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, jsonData);
        console.log("getPageInfoByUrl params",params);
        let options = this.options = new RequestOptions ({ headers: this.headers, search:params} );

        return this._http
          .get(this.pageInfoByUrl,options)
          .map(response => response.json())
          .catch((error:any) => Observable.throw(error || 'getHomeOffers error'));
        
      } catch (error) {
        console.log("getPageInfoByUrl",error);
      }
   }

   // Update agent_info,testimonial and page info in local storage
   // Will replace exsiting
   public updateLocalData(local_name,data){
  
      var localData;
      localStorage.setItem(local_name,JSON.stringify(data));
      console.log("update local Data -> "+local_name,data);
   }

   getHomeProducts(){
      try {
        this. doRequest();
        return this._http
          .get(emiGlobals.homeProductsList, this.options)
          .map(response => response.json())
          //.catch((error:any) => Observable.throw(error));
        
      } catch (error) {
        console.log("getHomeProducts",error);
      }
   }

   announcePageDataFetched(mission: string) {
    this.pageDataFetchedSource.next(mission);
   }

   announcePotalDataFetched(mission: string) {
    this.portalDataFetchedSource.next(mission);
   }
   announceExploreButtonClicked(mission:string){
    this.urlFetchedSource.next(mission);
  }

   public sentLeadInformation(lead){
    var totalLeadData = {};
    var other_info = {};

    // if(localStorage.getItem('lead_customer_info')){
    //   var localData = JSON.parse(localStorage.getItem('lead_customer_info'));
    //   Object.keys(localData).forEach((key) => totalLeadData["ci_"+key] = localData[key]);
    // }

    // if(localStorage.getItem('lead_contact')){
    //   var localData = JSON.parse(localStorage.getItem('lead_contact'));
    //   Object.keys(localData).forEach((key) => totalLeadData[key] = localData[key]);
    // }

    if(!totalLeadData['lead_type']){
      delete totalLeadData["prd_lead_type"];
    }

      totalLeadData['lead_type']      = 'call_back';
      totalLeadData['contact_number'] = lead.contact_number;
      totalLeadData['email'] = 'noemail@eloan.loan';
      totalLeadData['name'] = 'Call Back Number';
      totalLeadData['page_url']     = lead.page_slug;
      
    
      console.log("emileadSubmissionUrl",this.emileadSubmissionUrl);
      console.log("totalLeadData",totalLeadData);
      console.log("options",this.options); 
      
      return this._http
      .post(this.emileadSubmissionUrl,totalLeadData, this.options)
      .map(response => response.json())
      .catch(this.handleError);

  }


  public handleError(error: Response) {
    console.log(error);
    return [];
  }
  checkHasLocalData(){
      if(localStorage.getItem('lead_contact')){
        this.hasLocalLeadData = true;
        this.localLeadData = JSON.parse(localStorage.getItem('lead_contact'));
      }
      if(localStorage.getItem('lead_customer_info')){
        this.hasLocalCustomerInfoData = true;
        this.localCustomerInfoData = JSON.parse(localStorage.getItem('lead_customer_info'));
      }
    }
   getLocalLeadContactData(field) {
      if(this.hasLocalLeadData){
        console.log(this.localLeadData[field],field);
        return (this.localLeadData[field]?this.localLeadData[field]:null);
      }
    }
 



     

}



// WEBPACK FOOTER //
// ./src/app/shared/services/emi-base-info.service.ts